define(['core/iterate'], function (iterate) {
        return {
            create: function (sidebarNode, nodesForOpen, onSwitch) {

                iterate(sidebarNode.closeSideBar, function (node) {
                    node.addEventListener("click", function (e) {
                        e.preventDefault();
                        close();
                    });
                });

                nodesForOpen = nodesForOpen || [];

                iterate(nodesForOpen, function (node) {
                    node.addEventListener("click", function (e) {
                        e.preventDefault();
                        open()
                    });
                });

                function close() {
                    sidebarNode.wrap.classList.remove("active");
                }

                function open() {
                    let canvas = document.querySelector(".canvas")
                    if (sidebarNode.wrap.offsetHeight < canvas.offsetHeight) {
                        sidebarNode.wrap.style.minHeight = `${canvas.offsetHeight}px`
                    }
                    sidebarNode.wrap.classList.add("active");
                    
                }

                function switchModalStep(step, subStep, unActiveState) {

                    iterate(sidebarNode.menuSteps, function (node) {

                        if (node.getAttribute("data-step") == step && !unActiveState)
                            node.classList.add("active");
                        else
                            node.classList.remove("active");

                    });

                    iterate(sidebarNode.contentSteps, function (node) {

                        if (node.getAttribute("data-step") == step + "," + subStep)
                            node.classList.add("active");
                        else
                            node.classList.remove("active");

                    });


                    if (onSwitch)
                        onSwitch(step, subStep*1);

                    window.scrollTo(0,0);

                }

                return {
                    open: open,
                    close: close,
                    switch: switchModalStep
                }

            }
        }
    }
);
